<!--
Displays a wait/loading spinner.
Usage:
  HTML:
    <Spinner ref="spinner" />
  JavaScript:
    this.$refs.spinner.spin()
    this.$refs.spinner.stop()
@author bmk11u
-->
<template>
  <div class="switch-wrapper" @change="saveSetting">
    <label class="switch">
      <input type="checkbox" :checked="toggled" :aria-labelledby="props.labelledBy">
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script setup>
//Utilities
import { ref, watch, defineEmits } from 'vue'
import axios from 'axios'

const props = defineProps({
  name: String,
  toggle: Boolean,
  labelledBy: String
})

const emit = defineEmits(['settingSaved'])

//Data
const show =  ref(false)
const toggled = ref(props.toggle)

function saveSetting () {
  let newVal = ''
  toggled.value = !toggled.value
  if (toggled.value) {
    newVal = 'Y'
  } else {
    newVal = 'N'
  }
  axios.post('/timetable/settings', {}, {
    params: {
      settingName: props.name,
      settingValue: newVal
    }
  }).then(response => {
    //Display settings saved message
    if(response.status === 200) {
      emit('settingSaved')
    }
  })
}

//The toggle prop is undefined while the parent property gets the data from the api
//For some reason it doesn't update this child component when the prop is updated in the parent
//So need to use a watch to update the value
//Need to use a 'getter' as the first property because just watching the prop itself doesn't work
watch( 
  () => props.toggle, 
  (newVal) => {
    toggled.value = newVal
  }
)
</script>

<style scoped lang="scss">
.switch-wrapper {
  margin-right:11px;
}


/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: var(--uog-dark-blue);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--uog-dark-blue);
}

input:checked + .slider:before {
  -webkit-transform: translateX(22px);
  -ms-transform: translateX(22px);
  transform: translateX(22px);
  background-color: var(--uog-blue-10);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/*keyboard focus*/
.switch input:focus-visible + .slider {
    outline: solid 3px #FFDD00;
}

</style>
